// Model.js
// -----------------------
// @module Case
define("Code25.Utils", ["Backbone", "Utils", "Profile.Model", "Handlebars"], function (
    Backbone,
    Utils,
    ProfileModel,
    Handlebars
) {
    "use strict";

    return {
        mount: function mount(container) {
            Handlebars.registerHelper('debug', function (line) {

                console.log(line);
                return "";

            });

            Handlebars.registerHelper('if_or', function (A, B, options) {
                if (A || B) {
                    return options.fn(this);
                }
                return options.inverse(this);
            });

        }
    };
});

